import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";


export class PreferencesSelectComponent implements IController {
  value: any;
  isDisabled: any;
  onChange: Function

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('preferencesSelect', {
    bindings: {
      value: '<',
      isDisabled: '<',
      onChange: '&?'
    },
    templateUrl: 'app/modules/commons/components/preferences-select/preferences-select.html',
    controller: PreferencesSelectComponent
  });
